module.exports = __webpack_public_path__ + "static/media/test.2649194a.png";